module.exports = __webpack_public_path__ + "abce57a42a55712fcd4c9855e8ae6811.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/base/base-24.png
// module id = 1794
// module chunks = 0